import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';
import { Position, TooltipComponent } from './model';

@Component({
    selector: 'app-simple-mat-tooltip',
    templateUrl: './simple-mat-tooltip.component.html',
    styleUrls: ['./simple-mat-tooltip.component.scss'],
    host: { 'class': 'mdc-tooltip mat-mdc-tooltip' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimpleMatTooltipComponent implements TooltipComponent {

  @Input()
  message: string;

  @Input()
  set autoHideTimeout(value: number) {
    this._autoHideTimeout = value;
    this.autoHideHandler();
  }

  @Input()
  set position({ x, y }: Position) {
    this._top = y;
    this._left = x;
  }

  @Input()
  set show(isShow: boolean) {
    this._show = isShow;
    this._hide = !isShow;
    this.autoHideHandler();
  }

  get show() {
    return this._show;
  };

  constructor(private cdk: ChangeDetectorRef) {}

  update(): void {
    this.cdk.markForCheck();
  }

  @HostBinding('style.top.px')
  private _top: number = 0;

  @HostBinding('style.left.px')
  private _left: number = 0;

  @HostBinding('class.mat-mdc-tooltip-show')
  private _show: boolean = false;

  @HostBinding('class.mat-mdc-tooltip-hide')
  private _hide: boolean = true;

  private _autoHideTimeout: number = 0;

  private _autoHideTimeoutRef: number = -1;

  private autoHideHandler(): void {
    if (this._autoHideTimeoutRef > -1) {
      clearTimeout(this._autoHideTimeoutRef);
      this._autoHideTimeoutRef = -1;
    }
    if (this._show && this._autoHideTimeout > 0) {
      // @ts-ignore
      this._autoHideTimeoutRef = setTimeout(() => {
        if (this._show) {
          this._show = false;
          this._hide = true;
          this.update();
        }
      }, this._autoHideTimeout);
    }
  }

}
